<template >
    <h1 class="is-size-3 has-text-weight-medium m-0">
        <slot />
    </h1>
</template>